export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11496.6304407e.jpg";